import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-protect-pdf',
    imports: [],
    templateUrl: './blog-protect-pdf.component.html',
    styleUrl: './blog-protect-pdf.component.css'
})
export class BlogProtectPdfComponent {

}
